
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quran-foundation",
      function () {
        return require("private-next-pages/quran-foundation/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quran-foundation"])
      });
    }
  